import { Component, OnInit } from '@angular/core';
import { ResultsSportsTreeComponent } from '../../results-sports-tree/results-sports-tree.component';

@Component({
  selector: 'app-results-sport-competition-tree-mobile',
  templateUrl: './results-sport-competition-tree-mobile.component.html',
  styleUrls: ['./results-sport-competition-tree-mobile.component.less']
})

export class ResultsSportCompetitionTreeMobileComponent extends ResultsSportsTreeComponent {

}
